import React from 'react'
import {Typography} from './Typography'
import {CourseCard} from './CourseCard'

const NewCourses = ({courses}) => {
  return (
    <div className="py-5 bg-blue-500-to-900-y-invert shadow-2 lg:px-32">
      <Typography color="white" variant="heading-3xl" uppercase>
        últimas NOVIDADES
      </Typography>
      <Typography color="white">
        Todos os meses novos conteúdos para te manter sempre atualizado:
      </Typography>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {courses.map(course => (
          <CourseCard key={course.slug} {...course} />
        ))}
      </div>
    </div>
  )
}
export {NewCourses}
